export enum EVENT_SOURCES {
  BRANCH_RESTRICTION_MODAL = 'branchRestrictionModal',
  BRANCH_RESTRICTION_REMOVE_MODAL = 'branchRestrictionRemoveModal',
  BRANCH_RESTRICTIONS_SCREEN = 'branchRestrictionsScreen',

  MERGE_QUEUES_SCREEN = 'mergeQueuesScreen',
  MERGE_QUEUE_CREATE_EDIT_MODAL = 'mergeQueueCreateEditModal',
  MERGE_QUEUE_PULL_REQUESTS_MODAL = 'mergeQueuePullRequestsModal',
  MERGE_QUEUE_ACTIVATE_MODAL = 'mergeQueueActivateModal',
  MERGE_QUEUE_CLEAR_MODAL = 'mergeQueueClearModal',
  MERGE_QUEUE_DELETE_MODAL = 'mergeQueueDeleteModal',
  MERGE_QUEUE_DRAINING_MODAL = 'mergeQueueDrainingModal',
  MERGE_QUEUE_DEQUEUE_PR_MODAL = 'mergeQueueDequeuePullRequestModal',
  MERGE_QUEUE_MOVE_TO_TOP_PR_MODAL = 'mergeQueueMoveToTopPullRequestModal',
}
